const PROJECTS = '/projects'
const PROJECT_DETAIL = PROJECTS + '/:projectId'
const PROJECTS_NEW = PROJECTS + '/new'
const PROJECTS_EDIT = PROJECT_DETAIL + '/edit'
const OBJECT = PROJECT_DETAIL + '/objects/:objectId'
const TASKS = '/tasks'
const TASK = TASKS + '/:taskId'
const SETTINGS = '/settings'
const SETTINGS_REF = SETTINGS + '/:key'
const FILE_ORIGINAL = '/file/get/upload/:filename'
const FILE_PREVIEW = FILE_ORIGINAL + '/:size'
const FILE_PREVIEW_PDF = FILE_ORIGINAL + '/pdf'
const AVATAR_ORIGINAL = '/file/get/users/:filename'
const AVATAR_PREVIEW = AVATAR_ORIGINAL + '/:size'
const STATISTICS = '/statistics'

export const ROUTES = {
    ROOT: '/',
    ARCHIVE: '/archive',
    LOGIN: '/login',
    LOGOUT: '/logout',
    USERS: '/users',
    TASKS,
    TASK,
    PROJECTS,
    PROJECT_DETAIL,
    PROJECTS_NEW,
    PROJECTS_EDIT,
    OBJECT,
    STATISTICS,
    STATISTICS_MANAGER: STATISTICS + '/manager',
    STATISTICS_USER: STATISTICS + '/user',
    STATISTICS_USER_OBJECT: STATISTICS + '/user-object',
    STATISTICS_PROJECT: STATISTICS + '/project',
    STATISTICS_TASK: STATISTICS + '/task',
    SETTINGS,
    SETTINGS_REF,
    SETTINGS_OBJECTS: SETTINGS + '/work-object',
    SETTINGS_ROLES: SETTINGS + '/roles',
    SETTINGS_CONFIG: SETTINGS + '/config',
    SETTINGS_USERS: SETTINGS + '/user',
    SETTINGS_DEPARTMENTS: SETTINGS + '/department',
    FILE_ORIGINAL,
    FILE_PREVIEW,
    FILE_PREVIEW_PDF,
    AVATAR_ORIGINAL,
    AVATAR_PREVIEW,
    SEARCH: '/search',
    PRICE: '/price',
    CONTACTS: '/contacts',
    INFO: '/info',
    PROFILE: '/profile',
    TEST: '/test',
}

export const CHANNELS = {
    PROJECT: 'project.:projectId.history',
    OBJECT: 'project_work_object.:objectId.history',
    TASK: 'task.:taskId.history',
}
